export default __webpack_public_path__ + "static/media/login-1.5c723e7f.svg";